import React, { createContext, useReducer } from 'react'
export type Device = {
  _id: string;
  device_id: string;
  name: string;
  device_type: string;
  system?: string;
  system_id: string;
  connected: boolean;
  roles?: DeviceRole[]
  pump_info?: any;
  calibrated?: boolean;
  user_id: string;
  createdAt: Date;
}|
{
  _id: string;
  device_id: string;
  name: string;
  device_type: string;
  system?: string;
  system_id: string;
  connected: boolean;
  roles?: DeviceRole[]
  pump_info?: any;
  last_calibrated: Date;
  calibrated?: boolean;
  user_id: string;
  createdAt: Date;
}
;
export type DeviceRole = {
  outlet: number;
  role: string;
  status: 'on' | 'off'
}|
{
  pump: number;
  role: string;
}

type DevicesState = {
  devices: Device[] | null;
};

export type DevicesAction =
  | { type: 'SET_DEVICES'; payload: Device[] }
  | { type: 'ADD_DEVICE'; payload: Device }
  | { type: 'DELETE_DEVICE'; payload: Device };

type DevicesDispatch = (action: any) => void;

type DevicesContextType = DevicesState & {
  dispatch: DevicesDispatch;
};

export const DevicesContext = createContext<DevicesContextType>({
  devices: null,
  dispatch: () => {},
});


export const devicesReducer = (state: DevicesState, action: DevicesAction): DevicesState => {
  switch (action.type) {
    case 'SET_DEVICES': 
      return {
        devices: action.payload
      }
    case 'ADD_DEVICE':
      return {
        devices: [action.payload, ...(state.devices ?? [])]
      }
    case 'DELETE_DEVICE':
      return {
        devices: (state.devices ?? []).filter((d) => d._id !== action.payload._id)
      }
    default:
      return state
  }
}

type DevicesContextProviderProps = {
  children: React.ReactNode;
};

export const DevicesContextProvider = ({ children }: DevicesContextProviderProps) => {
  const [state, dispatch] = useReducer(devicesReducer, {
    devices: null,
  });

  return (
    <DevicesContext.Provider value={{...state, dispatch}}>
      { children }
    </DevicesContext.Provider>
  )
}